<template>
  <div>
    <div class="step-header">
      <h2 class="step-title">Escolha o conteúdo do seu cronograma</h2>
    </div>

    <div class="step-question-container" v-if="!loading">
      <span class="step-question">Selecione a(s) disciplina(s)</span>

      <multiselect v-model="disciplinesChosen" :options="disciplines" :multiple="true" :max="2"
                   :close-on-select="false" :clear-on-select="false" :show-labels="false" :preselect-first="false"
                   placeholder="Selecionar" label="name" track-by="id" :block-keys="['Tab','Enter']">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.name }}</span>
          </div>
        </template>

        <template slot="maxElements">
          Você selecionou o máximo de disciplinas permitidos.
        </template>
      </multiselect>

      <span class="description">Selecione até 2 disciplinas</span>
    </div>

    <div v-if="scheduleDisciplines.length > 0" class="step-question-container mt-7">
      <span class="step-question">Selecione o(s) curso(s)</span>

      <multiselect v-model="coursesChosen" :options="courses" :multiple="true" :close-on-select="false"
                   :clear-on-select="false" :show-labels="false" :preselect-first="false" placeholder="Selecionar"
                   label="name" track-by="id" :block-keys="['Tab','Enter']">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.name }}</span>
          </div>
        </template>
      </multiselect>
    </div>

    <div v-if="scheduleDisciplines.length > 0" class="step-question-container mt-7">
      <span class="step-question">Selecione uma cor para o seu cronograma</span>

      <multiselect v-model="colorChosen" :options="colors" :show-labels="false" :preselect-first="true"
                   placeholder="Selecionar" label="color" track-by="value" :block-keys="['Tab','Enter']">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div class="d-flex align-center">
              <span class="color-palette" :style="'background: ' + props.option.value"></span>
              <span class="option__title">{{ props.option.name }}</span>
            </div>
          </div>
        </template>

        <template slot="singleLabel" slot-scope="props">
          <div class="d-flex align-center">
            <span class="color-palette" :style="'background: ' + props.option.value"></span>
            <span>{{ props.option.name }}</span>
          </div>
        </template>
      </multiselect>
    </div>

    <div class="text-center" v-if="loading">
      <img src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/gif.gif" alt="Carregando">
    </div>

    <div class="step-buttons d-flex justify-content-end">
      <v-btn rounded class="btn next-step-button only-button primary-button" large v-if="scheduleDisciplines.length > 0"
             color="#F47D3A" @click="nextStep">
        Próxima
        <v-icon class="ml-3">mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import './style.scss'
import {mapActions, mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'StepOne',

  components: {
    Multiselect
  },

  data() {
    return {
      colors: [
        {
          name: 'Roxo Escuro',
          value: '#7C56F6'
        },
        {
          name: 'Roxo',
          value: '#AD70F1'
        },
        {
          name: 'Azul',
          value: '#3B94F1'
        },
        {
          name: 'Verde',
          value: '#4DCDCC'
        },
        {
          name: 'Laranja',
          value: '#F47D3A'
        },
        {
          name: 'Laranja Claro',
          value: '#F7B329'
        },
      ]
    }
  },

  computed: {
    ...mapGetters([
      'courses',
      'disciplines',
      'isUpdate',
      'loading',
      'scheduleColor',
      'scheduleCourses',
      'scheduleDisciplines'
    ]),

    colorChosen: {
      get() {
        return this.colors.find(color => color.value === this.scheduleColor)
      },

      set({value}) {
        this.setScheduleColor(value)
      }
    },

    coursesChosen: {
      get() {
        return this.scheduleCourses
      },

      set(value) {
        this.setScheduleCourses(value)
      }
    },

    disciplinesChosen: {
      get() {
        return this.scheduleDisciplines
      },

      set(value) {
        this.setScheduleDisciplines(value)
      }
    },
  },

  async mounted() {
    this.startLoading()
    await this.loadDisciplines()
    if (this.isUpdate) {
      await this.loadEditableScheduleConfig()
    }
    this.stopLoading()
  },

  methods: {
    ...mapActions([
      'loadDisciplines',
      'loadEditableScheduleConfig',
      'setCreationStep',
      'setScheduleColor',
      'setScheduleCourses',
      'setScheduleDisciplines',
      'startLoading',
      'stopLoading'
    ]),

    nextStep() {
      this.setCreationStep(2)
    },
  }
}
</script>
